var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.flag)?_c('div',{staticClass:"toast"},[_c('p',[_vm._v(_vm._s(_vm.content))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }